import { CONST_AUTH } from './';
import { itrState, itrAction } from 'store/initialState';

export default (
  state: itrState,
  action: itrAction,
): { [key: string]: (act: itrAction) => itrState } => {
  const reducer = {
    [CONST_AUTH.SET_USER_DATA](act: itrAction) {
      sessionStorage.setItem('digiV-session', `${act?.data?.hash}`);
      return {
        ...state,
        auth: act?.data,
      };
    },
    [CONST_AUTH.LOGOUT](act: itrAction) {
      sessionStorage.removeItem('digiV-session');
      sessionStorage.clear;
      return {
        ...state,
        auth: false,
      };
    },
  };
  return reducer;
};
